export const SecuritySelectors = {
    Bans: (state) => state.Security.bans,
    Allowlist: (state) => state.Security.allowlist,
    Loading: (state) => state.Security.loading,
    Error: (state) => state.Security.error,
};
